<template>
  <div v-if="showRelatedPages" class="related-child-section">
    <v-expansion-panels flat static v-model="expandedPanels">
      <v-expansion-panel>
        <v-expansion-panel-title id="related-pages-section">
          <h1>Pages in this Section</h1>
        </v-expansion-panel-title>
        <v-expansion-panel-text class="p-0">
          <div class="related-child-items">
            <app-link
              class="related-child-link mb-0"
              v-for="{ name, path } in relatedPages"
              :to="`/module/${moduleId}/page/${path}`"
            >
              <related-page-card :title="name.trim()" />
            </app-link>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import { CSBase } from '@complispace/cs-design-system';
import { mapGetters, mapState } from 'vuex';
import RelatedPageCard from '@/components/content/RelatedPageCard';
import treeutils from '@/lib/treeutils';
import AppLink from '@/components/core/AppLink';

export default {
  name: 'RelatedPageSection',
  data() {
    return {
      expandedPanels: [0]
    };
  },
  extends: CSBase,
  components: { RelatedPageCard, AppLink },
  props: {
    childPages: {
      type: Array,
      default: () => []
    },
    moduleId: {
      type: Number
    },
    currentPagePath: {
      type: String,
      default: ''
    }
  },

  computed: {
    ...mapState({
      app: (state) => state.app,
      viewType: (state) => state.authorisation.viewType,
      isPublicViewMode: (state) => state.appearance.isPublicViewMode,
      pageCommitOID: (state) => state.data.pageCommitOID
    }),
    ...mapGetters({
      contextItemValues: 'clientContext/values',
      getMasterTOC: 'data/getMasterTOC',
      isAdminDraftView: 'authorisation/isAdminDraftView'
    }),
    relatedPages() {
      // If the master toc is not initialised, return an empty array
      if (!this.app.initialised) {
        return [];
      }
      const masterTOC = this.getMasterTOC(this.moduleId, this.contextItemValues, this.viewType);
      if (!masterTOC?.children) {
        return [];
      }
      const node = treeutils.findNodeByPath([masterTOC], this.currentPagePath);

      // selected property is only available in admin mode
      return (
        node?.children?.filter((child) =>
          child.selected !== undefined ? child.selected : child.visible
        ) || []
      );
    },
    showRelatedPages() {
      return (
        this.relatedPages?.length &&
        !this.isPublicViewMode &&
        !this.isAdminDraftView &&
        !this.pageCommitOID
      );
    }
  },
  watch: {
    showRelatedPages: {
      immediate: true,
      handler(newShowRelatedPages) {
        this.$emit('showRelatedPages', newShowRelatedPages);
      }
    }
  }
};
</script>

<style scoped>
.related-child-items {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}
.v-expansion-panel-title {
  padding: 0px 1px 16px 1px;
}
.v-expansion-panel :hover {
  background-color: transparent;
}
.v-expansion-panel-text :deep(.v-expansion-panel-text__wrapper) {
  padding: 0px;
}
</style>
